import { useState, useRef } from 'react'
import logo from '../../assets/sumSystem_logo.png'
import { useAuthContext } from '../../hooks/useAuthContext'

export default function LoginScreen() {
	const { dispatch } = useAuthContext()
	const [error, setError] = useState('')

	//using an uncontrolled input values
	//Could have done much easier with useState
	const passwordRef = useRef()

	const handleLogin = e => {
		setError('')
		e.preventDefault()

		//the app takes any 5 characters as a password
		//this is small validation from my side :)
		if (passwordRef.current.value.length < 5) {
			setError('Oops... password too short')
			return
		}
		dispatch({ type: 'LOGIN', payload: true })
	}

	return (
		<div className='max-w-md rounded-md shadow-md bg-white mt-40 mx-auto p-5 flex flex-col items-center'>
			<img className='my-5 h-24 object-contain' src={logo} alt='logo' />
			<form onSubmit={handleLogin} className='flex flex-col items-center'>
				<label className='text-xs text-gray-500'>
					Login to your account and submit a payment card.
				</label>
				<input
					ref={passwordRef}
					className='border my-3 p-3 w-24 rounded-md text-center bg-gray-100 text-sm'
					type='password'
					maxLength={5}
					required
					onChange={() => setError('')}
					placeholder='INSERT PIN'
				/>
				{error && <p className='text-red-500 text-xs'>{error}</p>}
				<button className='submitBtn'>Login</button>
			</form>
		</div>
	)
}
